import { render, staticRenderFns } from "./AddressCardInput.vue?vue&type=template&id=5d94bcec&scoped=true&lang=pug&"
import script from "./AddressCardInput.vue?vue&type=script&lang=js&"
export * from "./AddressCardInput.vue?vue&type=script&lang=js&"
import style0 from "./AddressCardInput.vue?vue&type=style&index=0&id=5d94bcec&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d94bcec",
  null
  
)

/* custom blocks */
import block0 from "./AddressCardInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports